import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Superadmin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Salgschef',
  [ManagerRole.SalesLeadership]: 'Salgsledelse',
  [ManagerRole.ContentManager]: 'Indholdsansvarlig',
  [ManagerRole.OnboardingManager]: 'Onboarding-ansvarlig',
  [ManagerRole.OccAgent]: 'Callcenter-medarbejder',
};
